import React, {useContext} from 'react';
import {useTranslation} from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import Context from 'utils/Context';

import Link from 'components/Link';
import NewsletterSubscriptionForm from 'components/NewsletterSubscriptionForm';

import './Footer.scss';
import europeanCommissionLogo from './logos/commission-europeenne.png';
import futuraCinemaLogo from './logos/futuracinema.png';
// import parisAndCoLogo from './logos/paris-and-co.png';
import linccLogo from './logos/lincc.png';
import france2030 from './logos/france-2030.png';

const Footer = () => {
  const {t} = useTranslation();
  const {modele} = useContext(Context);
  const contactContent = ((modele.pages && modele.pages.contact) || {}).content;
  return (
    <div className="footer container">
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <div className="rte-content footer contact" dangerouslySetInnerHTML={{__html: contactContent}} />
        </Grid>
        <Grid item xs={12} md={4} className="footer center-column">
          <div className="footer logos">
            <div>
              <img src={france2030} alt="France 2030 logo" width={60} />
            </div>
            <div>
              <img src={futuraCinemaLogo} alt="futura cinema logo" width={60} />
            </div>
            <div>
              <img src={linccLogo} alt="lincc logo" width={80} />
            </div>
            <div>
              <img src={europeanCommissionLogo} alt="european commission logo" width={80} />
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={4} className="footer right-column">
          <NewsletterSubscriptionForm />
          <div className="footer links">
            <Link url="/cgv">{t('cgv')}</Link> - <Link url="/faq">{t('faq')}</Link> -{' '}
            <Link url="/about">{t('a-propos')}</Link>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default Footer;
